import "core-js/modules/web.dom-collections.iterator.js";
import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import SingleFile from './SingleFile';
import Button from '../Button';
import Stack from '../Stack';
import { styled } from '../styles';
function getNewId() {
  // generate unique file id
  return Math.floor(Math.random() * 10 ** 15);
}
const DropZoneContainer = styled('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    border: "2px dashed ".concat(theme.palette.primary.main),
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    background: theme.palette.background.default,
    height: theme.spacing(10),
    outline: 'none'
  };
});
const FileUpload = _ref2 => {
  let {
    accept,
    maxSize = 300 * 1024,
    maxFiles,
    uploadUrl,
    multiple = true,
    onError,
    btnSingleLabel,
    dragSingleLabel,
    btnMultiLabel,
    dragMultiLabel,
    onChange,
    onUploadCallback
  } = _ref2;
  const [files, setFiles] = useState([]);
  const onDrop = useCallback((accFiles, rejFiles) => {
    /* remove duplicates */
    const removeDuplicatesAcc = accFiles.filter(accFile => !files.find(_ref3 => {
      let {
        file
      } = _ref3;
      return file.name === accFile.name;
    }));
    const removeDuplicatesRej = rejFiles.filter(rejFile => !files.find(_ref4 => {
      let {
        file
      } = _ref4;
      return file.name === rejFile.file.name;
    }));
    let mappedAcc = removeDuplicatesAcc.map(file => ({
      file,
      errors: [],
      id: getNewId()
    }));
    let mappedRej = removeDuplicatesRej.map(rejectedFile => ({
      ...rejectedFile,
      id: getNewId()
    }));
    const errorFiles = mappedRej;
    /* remove excess files when it exceeds maxFiles */
    if (multiple && Boolean(maxFiles) && maxFiles > 0) {
      const tooManyFiles = mappedRej.filter(file => {
        if (file.errors.length === 1) {
          return file.errors[0].code === 'too-many-files';
        }
        return [];
      });
      const maximumFiles = maxFiles - files.length;
      if (tooManyFiles.length > 0) {
        const slicedRejectedFiles = tooManyFiles.slice(0, maximumFiles);
        mappedRej = slicedRejectedFiles.map(file => ({
          ...file,
          errors: []
        }));
      }
      const filesWithErrors = [].concat(errorFiles.filter(errFile => mappedRej.every(rejFile => errFile.id !== rejFile.id)), mappedRej.filter(errFile => mappedRej.every(rejFile => errFile.id !== rejFile.id)));
      if (typeof onError === 'function' && filesWithErrors.length > 0) {
        onError('file', filesWithErrors, "".concat(filesWithErrors.length > 1 ? "exceeds max file number + ".concat(filesWithErrors.length - 1, " other errors") : 'exceeds max file number'), 'files-with-errors');
      }
      mappedAcc = mappedAcc.slice(0, maximumFiles);
    }
    setFiles(curr => [...curr, ...mappedAcc, ...mappedRej]);
  }, [files]);
  const onUpload = (file, url, resp) => {
    setFiles(curr => curr.map(fw => {
      if (fw.file === file) {
        return {
          ...fw,
          url,
          response: resp
        };
      }
      return fw;
    }));
  };
  const onDelete = file => {
    setFiles(curr => curr.filter(fw => fw.file !== file));
  };
  useEffect(() => {
    if (typeof onChange === 'function') {
      onChange(files);
    }
  }, [files]);
  const {
    getRootProps,
    getInputProps,
    open
  } = useDropzone({
    onDrop,
    accept,
    maxSize,
    maxFiles,
    multiple,
    noClick: true
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, files.map(fileWrapper => /*#__PURE__*/React.createElement("div", {
    key: fileWrapper.id
  }, /*#__PURE__*/React.createElement(SingleFile, {
    onDelete: onDelete,
    onUpload: onUpload,
    file: fileWrapper.file,
    errors: fileWrapper.errors,
    uploadUrl: uploadUrl,
    onError: onError,
    onUploadCallback: onUploadCallback
  }))), !multiple && files.length === 1 || multiple && Boolean(maxFiles) && files.length >= maxFiles ? null : /*#__PURE__*/React.createElement(DropZoneContainer, getRootProps(), /*#__PURE__*/React.createElement("input", getInputProps()), /*#__PURE__*/React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    spacing: 2,
    marginLeft: "20px"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: open
  }, multiple ? btnMultiLabel : btnSingleLabel), /*#__PURE__*/React.createElement("p", null, multiple ? dragMultiLabel : dragSingleLabel))));
};
export default FileUpload;